import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "16",
  viewBox: "0 0 15 16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M5.83333 3.83333L5.40333 4.995C4.84 6.51833 4.55833 7.28 4.0025 7.83583C3.44667 8.39167 2.685 8.67333 1.16167 9.23667L0 9.66667L1.16167 10.0967C2.685 10.66 3.44667 10.9425 4.0025 11.4975C4.55833 12.0525 4.84 12.815 5.40333 14.3383L5.83333 15.5L6.26333 14.3383C6.82667 12.815 7.10917 12.0533 7.66417 11.4975C8.21917 10.9417 8.98167 10.66 10.505 10.0967L11.6667 9.66667L10.505 9.23667C8.98167 8.67333 8.22 8.39167 7.66417 7.83583C7.10833 7.28 6.82667 6.51833 6.26333 4.995L5.83333 3.83333ZM12.5 0.5L12.3158 0.9975C12.0742 1.65083 11.9533 1.9775 11.7158 2.215C11.4775 2.45333 11.1508 2.57417 10.4975 2.815L10 3L10.4983 3.18417C11.1508 3.42583 11.4775 3.54667 11.715 3.78417C11.9533 4.0225 12.0742 4.34917 12.315 5.0025L12.5 5.5L12.6842 5.0025C12.9258 4.34917 13.0467 4.0225 13.2842 3.785C13.5225 3.54667 13.8492 3.42583 14.5025 3.185L15 3L14.5017 2.81583C13.8492 2.57417 13.5225 2.45333 13.285 2.21583C13.0467 1.9775 12.9258 1.65083 12.685 0.9975L12.5 0.5Z",
      fill: "url(#First_Draft_Stars_Filled_svg__paint0_linear_2328_2728)"
    }, null, -1),
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "First_Draft_Stars_Filled_svg__paint0_linear_2328_2728",
        x1: "0.0294695",
        y1: "8",
        x2: "15",
        y2: "8",
        gradientUnits: "userSpaceOnUse"
      }, [
        _createElementVNode("stop", { "stop-color": "#DB44FA" }),
        _createElementVNode("stop", {
          offset: "1",
          "stop-color": "#4C61FF"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }